// import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Box, Card, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useParams } from 'react-router-dom';
import RouteConstants from '../../constants/routeConstants';
import { useEventState } from '../../stores/eventStore';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import { useThemeState } from '../../hookState/ThemeState';
import { createTheme } from '@mui/system';
import EventDetailsComponent from '../../sharedcomponents/detailsComponent/EventDetailsComponent';
import EventCardsDetails from '../../sharedcomponents/detailsComponent/EventCardsDetails';
import { resetSaveAsDraftState } from '../../hookState/AgentSaveAsDraftState';
import Helper from '../../utility/helper';
import Weather from '../../sharedcomponents/Weather';
import Logo from '../../assets/images/logo.png';
import DefaultEvent from '../../assets/images/default_event.jpg';
// import { Link } from 'react-router-dom';
// import Helper from '../../utility/helper';
// import EventTabs from '../../sharedcomponents/eventTabs/eventTabs';
const theme = createTheme();

const useStyles = makeStyles(() => ({
    subPaperContent: {
        boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.4)',
        borderRadius: theme.spacing(3),
        padding: theme.spacing(3),
        maxWidth: '100%',
        display: 'flex',
        margin: '10px 25px 25px 25px',
        maxWidth: '100%',
        boxSizing: 'border-box',
        position: 'relative'
    },
    viewMoreLink: {
        position: 'absolute',
        cursor: 'pointer',
        color: '#17408B',
        textDecoration: 'none',
        fontSize: '16px',
        '&:hover': {
            color: 'darkblue',
        },
    },
}));

const EventDetail = (props) => {
    const eventInfo = Helper.getStorage('eventInfo');
    const eventState = useEventState();
    const classes = useStyles();
    let params = useParams();
    const [viewmore, setviewmore] = useState(false);
    const themeState = useThemeState();
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');


    useEffect(() => {
        resetSaveAsDraftState();
        const location = props.history.location;
        if (location && typeof location.state !== 'undefined' && location.state.event) {
            eventState.eventDetail.set(event);
        }

        if (params.eventID && userInfo && userInfo.userID &&
            (!eventState.eventDetail.get() ||
                (eventState.eventDetail.get() && !eventState.eventDetail.get().notes))) {
            ApiHelper.get(APIURLConstants.GET_EVENT(params.eventID, userInfo.userID))
                .then((res) => {
                    if (res.data) {
                        eventState.eventDetail.set(res.data);
                    }
                })
        }
    }, []);


    //    const  handleviewmore = () =>{
    //     setviewmore(!viewmore);
    //     }
    // console.log("eventState",eventState);
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                maxHeight: 'calc(100vh - 120px)',
                alignItems: 'center',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: {
                        xs: 'column',
                        md: 'row',
                    },
                    width: '100%',
                    justifyContent: 'space-between',
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                }}
            >
                <Box
                    component="img"
                    style={{ height: 100, margin: '20px' }}
                    alt="logo."
                    src={
                        !themeState.eventEnabled.value
                            ? Logo
                            : themeState.eventImageUrl.value != ''
                                ? themeState.eventImageUrl.value
                                : DefaultEvent
                    }
                />
                <Box>
                    <Weather />
                </Box>
            </Box>
            <Box
                sx={{ width: '100%', padding: '15px' }} className="ck-content1">
                <Card classes={{ root: classes.subPaperContent }} >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%'
                        }}
                    >
                        <Box>
                            {
                                eventState.eventDetail.get() != null &&
                                <EventDetailsComponent data={eventState.eventDetail.get().notes} />
                            }
                        </Box>
                        {/* <Box
            sx={{
                display:'flex',
                justifyContent:'flex-end'
            }}
            >
                        <Typography component={Link} to="#"   onClick={handleviewmore} className={classes.viewMoreLink} sx={{ top:viewmore ? '360px' :'', right: viewmore ? '15px' :'20px',}}>{viewmore ? "View More" : "View Less" }</Typography>
            </Box> */}
                    </Box>
                </Card>
                <Card style={{ boxShadow: 'none', borderRadius: 'unset', backgroundColor: 'unset' }}>
                    {userInfo && <EventCardsDetails data={eventState.eventDetail.get()} history={props.history} />}
                </Card>
            </Box>
        </Box>
    );
};

export default {
    routeProps: {
        path: RouteConstants.EVENT_DETAIL,
        component: EventDetail,
    },
    name: 'EventDetail',
};
